/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconRouteAltRight = createReactComponent("outline", "route-alt-right", "IconRouteAltRight", [["path", { "d": "M16 3h5v5", "key": "svg-0" }], ["path", { "d": "M8 3h-5v5", "key": "svg-1" }], ["path", { "d": "M21 3l-7.536 7.536a5 5 0 0 0 -1.464 3.534v6.93", "key": "svg-2" }], ["path", { "d": "M6 6.01v-.01", "key": "svg-3" }], ["path", { "d": "M8 8.02v-.01", "key": "svg-4" }], ["path", { "d": "M10 10v.01", "key": "svg-5" }]]);

export { IconRouteAltRight as default };
//# sourceMappingURL=IconRouteAltRight.mjs.map
